// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__1wWyI","info":"Note_info__7zqAx","note":"Note_note__2uCnO","actions":"Note_actions__3gEAz"};